import { render } from "./LegalDocumentView.vue?vue&type=template&id=2ccfe92c&scoped=true"
import script from "./LegalDocumentView.vue?vue&type=script&lang=js"
export * from "./LegalDocumentView.vue?vue&type=script&lang=js"

import "./LegalDocumentView.vue?vue&type=style&index=0&id=2ccfe92c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccfe92c"]])

export default __exports__